import script from "./SaveUserGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveUserGroup.vue?vue&type=script&setup=true&lang=js"

import "./SaveUserGroup.vue?vue&type=style&index=0&id=8576afa4&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8576afa4"]])

export default __exports__